import { createFileRoute } from '@tanstack/react-router';
import {
  dashboardLoaderDeps,
  merchantDevicesHealthQueryOptions,
  dashboardRecentReceiptsQueryOptions,
  DashboardPage,
  merchantSummaryQueryOptions,
  validateDashboardSearch,
} from '@/features/dashboard';
import { useAuthStore } from '@/stores/auth';

export const Route = createFileRoute('/_authed/dashboard')({
  validateSearch: validateDashboardSearch,
  loaderDeps: ({ search }) => dashboardLoaderDeps(search),
  loader: ({ cause, context, deps }) => {
    const activeBranchId = useAuthStore.getState().activeBranchId;
    const branchId = activeBranchId && activeBranchId !== 'all' ? activeBranchId : undefined;

    void context.queryClient.prefetchQuery(
      merchantSummaryQueryOptions({
        period: deps.period,
        from: deps.from,
        to: deps.to,
        branch_id: branchId,
      }),
    );
    void context.queryClient.prefetchQuery(
      merchantDevicesHealthQueryOptions({
        branch_id: branchId,
      }),
    );

    if (cause === 'enter') {
      void context.queryClient.prefetchQuery(
        dashboardRecentReceiptsQueryOptions({
          period: '7d',
          branch_id: branchId,
          page: 1,
          page_size: 5,
        }),
      );
    }
  },
  component: DashboardRouteComponent,
});

function DashboardRouteComponent() {
  return <DashboardPage />;
}
